<template>
  <AhaInfoBox>
    {{ $i18nPresenter.t('Please note: This question is not scored. You can convert it into a Quiz slide by') }}
    <a class="right-col--link" @click="showSlideTypeSelectionAction()">{{ $i18nPresenter.t('changing its Type') }}</a>.
  </AhaInfoBox>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions('rightNav', ['showSlideTypeSelectionAction']),
  },
}
</script>
